import { usePath } from './lib/router';
import { Home } from './screens/Home';
import { Finder } from './screens/Finder';
import { Owner } from './screens/Owner';
import { CodeEntry } from './screens/CodeEntry';
import { NotFound } from './screens/NotFound';
import { Helper } from './screens/Helper';

export function App() {
  const path = usePath();
  const [, first = '', second = ''] = path.split('/');
  const segment = decodeURIComponent(second);

  if (path === '/' || path === '') return <Home />;
  if ((first === 't' || first === 'T') && segment) return <Finder rawId={segment} />;
  if (first === 'o' && segment) return <Owner rawId={segment} />;
  if (first === 'code' || first === 'kod') return <CodeEntry />;
  if (first === 'helper') return <Helper />;
  return <NotFound />;
}
